import { styled } from '@linaria/react';
import { NoStyleButton } from '../helpers/NoStyleButton';
const _exp = /*#__PURE__*/() => ({
  selected
}) => selected ? 1 : 0;
export const ImageRefContainer = /*#__PURE__*/styled('div')({
  name: "ImageRefContainer",
  class: "ik2lty4",
  propsAsIs: false,
  vars: {
    "ik2lty4-0": [_exp()]
  }
});
export const ImageContainer = /*#__PURE__*/styled('div')({
  name: "ImageContainer",
  class: "iqprj96",
  propsAsIs: false
});
export const ImagesNumber = /*#__PURE__*/styled('div')({
  name: "ImagesNumber",
  class: "ip5plnf",
  propsAsIs: false
});
export const ImagesWrapper = /*#__PURE__*/styled('div')({
  name: "ImagesWrapper",
  class: "i1skzb5o",
  propsAsIs: false
});
export const baseArrowStyles = "b1c5g550";
export const StyledArrowRight = /*#__PURE__*/styled('div')({
  name: "StyledArrowRight",
  class: "s11cn9pv",
  propsAsIs: false
});
export const StyledArrowLeft = /*#__PURE__*/styled('div')({
  name: "StyledArrowLeft",
  class: "sxcx9p3",
  propsAsIs: false
});
const _exp19 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '100%' : '64%';
const _exp20 = /*#__PURE__*/() => ({
  height
}) => height || 340;
const _exp24 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '100%' : '1.5';
export const ImageGalleryMain = /*#__PURE__*/styled('div')({
  name: "ImageGalleryMain",
  class: "i11wd0xi",
  propsAsIs: false,
  vars: {
    "i11wd0xi-0": [_exp19()],
    "i11wd0xi-1": [_exp20(), "px"],
    "i11wd0xi-2": [_exp24()]
  }
});
export const ImageGallery = /*#__PURE__*/styled('section')({
  name: "ImageGallery",
  class: "i1fxb0mw",
  propsAsIs: false
});
const _exp29 = /*#__PURE__*/() => NoStyleButton;
export const CenterClickArea = /*#__PURE__*/styled(_exp29())({
  name: "CenterClickArea",
  class: "cwrc7ux",
  propsAsIs: true
});
const _exp30 = /*#__PURE__*/() => ({
  hasCenterClick
}) => hasCenterClick ? '33%' : '70%';
export const NextClickArea = /*#__PURE__*/styled('div')({
  name: "NextClickArea",
  class: "n1l057np",
  propsAsIs: false,
  vars: {
    "n1l057np-0": [_exp30()]
  }
});
const _exp31 = /*#__PURE__*/() => ({
  hasCenterClick
}) => hasCenterClick ? '33%' : '30%';
export const PrevClickArea = /*#__PURE__*/styled('div')({
  name: "PrevClickArea",
  class: "p4j4ofo",
  propsAsIs: false,
  vars: {
    "p4j4ofo-0": [_exp31()]
  }
});
export const ThumbsWrapper = /*#__PURE__*/styled('div')({
  name: "ThumbsWrapper",
  class: "t1l3ca9g",
  propsAsIs: false
});
const _exp32 = /*#__PURE__*/() => ({
  hidden
}) => hidden ? 'none' : 'inline-block';
export const ThumbsContainer = /*#__PURE__*/styled('div')({
  name: "ThumbsContainer",
  class: "tcdv3wc",
  propsAsIs: false,
  vars: {
    "tcdv3wc-0": [_exp32()]
  }
});
export const Thumb = /*#__PURE__*/styled('div')({
  name: "Thumb",
  class: "t1g0h76g",
  propsAsIs: false
});

require("./style.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");